import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ApplicationStateService } from '@praceprofirmy/shared-domain';

@Component({
  imports: [RouterOutlet],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'jpdesignstudio-crm-web';

  protected readonly appState = inject(ApplicationStateService);

  constructor() {
    this.appState.loadUsersToSystem();
  }
}
